(ns hypnos.backoffice.panel.dashboard
  "The sleeplan dashboard page."
  (:require [hypnos.backoffice.tile.consults :as consults]
            [hypnos.config :as config]
            [hypnos.graphql.queries :as queries]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helper Functions

(defn- iris-actionable-consults-filter
  "Filter (function) for consults by superuser, i.e. consults

    * in-progress status
    * pending w/ image and only fit-kit recommendation(s)
    * completed w/ image, fit-kit mask, but no sized mask
  "
  [consult]
  (let [consult-status (:consult/status consult)
        patient        (:consult/patient consult)
        recomm-model   (:recommendation/model (first (:consult/recommendations consult)))]
    (or (= :consult-state/in-progress consult-status)
        (and (= :consult-state/pending consult-status)
             (:patient/image patient)
             (= :mask-size/fit-kit (:model/size recomm-model)))
        (and (= :consult-state/completed consult-status)
             (:patient/image patient)
             (= :mask-size/fit-kit (:model/size recomm-model))))))

(defn- new-consults-filter
  "Filter (function) for 'new' consults."
  [consult]
  (contains? #{:consult-state/new} (:consult/status consult)))

(defn- therapist-actionable-consults-filter
  "Filter (function) for consults actionable by the therapist, i.e. consults

     * pending w/ image
     * pending w/o image
  "
  [consult]
  (let [consult-status (:consult/status consult)]
    (= :consult-state/pending consult-status)))


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The Iris dashboards panel"
  []
  (rf/dispatch [:amplify/query
                queries/get-consults
                {:limit  config/PAGE-SIZE
                 :offset 0}
                :backoffice/set-consults
                :backoffice/noop])
  (fn []
    (let [loading? (rf/subscribe [:backoffice/gql-request-in-progress?])]
      [:section.section.is-main-section
       ;; in-progress, pending consults w/o image, and completed consults w/o image within last 30 days
       [:div.card.has-table.has-mobile-sort-spaced
        [:div.card-header
         [:p.card-header-title
          [:span.icon
           [:i.mdi.mdi-18px.mdi-handshake]]
          (str (tr :ui.label/in-progress) " " (tr :ui.label/consults))]
         [:button.button.is-small
          {:type     :button
           :disabled @loading?
           :on-click (fn [_]
                       (rf/dispatch [:amplify/query
                                     queries/get-consults
                                     {:limit  config/PAGE-SIZE
                                      :offset 0}
                                     :backoffice/set-consults
                                     :backoffice/noop]))}
          [:span.icon
           [:i.mdi.mdi-refresh.default]]
          [:span (tr :ui.label/refresh)]]]
        [:div.card-content
         [consults/consults-tile iris-actionable-consults-filter]]]
       ;; new consults
       [:div.card.has-table.has-mobile-sort-spaced
        [:div.card-header
         [:p.card-header-title
          [:span.icon
           [:i.mdi.mdi-18px.mdi-handshake]]
          (str (tr :ui.label/new) " " (tr :ui.label/consults))]]
        [:div.card-content
         [consults/consults-tile new-consults-filter]]]
       ;; pending consults
       [:div.card.has-table.has-mobile-sort-spaced
        [:div.card-header
         [:p.card-header-title
          [:span.icon
           [:i.mdi.mdi-18px.mdi-handshake]]
          (str (tr :ui.label/pending) " " (tr :ui.label/consults))]]
        [:div.card-content
         [consults/consults-tile therapist-actionable-consults-filter]]]])))
